import React, { useEffect, useRef } from 'react';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';
import Marquee from 'react-fast-marquee';
import TestimonialBanner from '@/assets/images/testimonials.png';

const testimonials = [
  { 
    text: "The plan is definitely worth the price and great customer service!", 
    author: "Akshay Kadam",
    subtitle: "2 year protection on LASERON Q10",
    stars: 5
  },
  { 
    text: "In a stressful time, you made it so easy and painless to file my claim.", 
    author: "Biswaranjan Kar",
    subtitle: "1 year protection on HydroSipr 1000ml",
    stars: 3
  },
  { 
    text: "Fast response, I got my new part sent out and ordered in less than 48 hours. Thank you.", 
    author: "Manan Dang",
    subtitle: "2 year protection on IZI Drive N700 Dash Camera",
    stars: 4
  },
  { 
    text: "The process was very easy and I appreciate being able to do everything online.", 
    author: "Sanjay Guria",
    subtitle: "1 year protection on MopX2",
    stars: 5
  },
  { 
    text: "Quick, friendly and professional service. Extremely happy.", 
    author: "Chetan Phalke",
    subtitle: "2 year protection on HydroPitcher 2000ml",
    stars: 4
  },
  { 
    text: "Absolutely the easiest claim process I’ve ever experienced!", 
    author: "Tapas Das",
    subtitle: "1 year protection on IZI One Pro 5.7K Action Camera",
    stars: 5
  },
  { 
    text: "Super smooth experience from start to finish.", 
    author: "Simranjeet Singh",
    subtitle: "2 year protection on LASERON S10",
    stars: 3
  },
  { 
    text: "Customer support was responsive and actually helpful.", 
    author: "Sarthak Dhingra",
    subtitle: "1 year protection on Vidorra Teak Wood Cake Stand Gold",
    stars: 4
  },
  { 
    text: "Got my issue resolved faster than expected.", 
    author: "Mukta Martens",
    subtitle: "2 year protection on IZI Brephos Professional Drone",
    stars: 5
  },
  { 
    text: "Very transparent process, no hidden surprises.", 
    author: "Yathannsh Kulshrestha",
    subtitle: "1 year protection on HydroUltra 400ml",
    stars: 3
  },
  { 
    text: "Everything was handled professionally and quickly.", 
    author: "Aayush Biyani",
    subtitle: "2 year protection on Nimbus Cloud Cube Pouf Stool",
    stars: 5
  },
  { 
    text: "Simple, efficient and worth every rupee.", 
    author: "Kishan Patel",
    subtitle: "1 year protection on IZI One Lite 5K Action Camera",
    stars: 4
  },
];

const SelfService: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const imageRef   = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // remove any translate classes so it sits perfectly centered
            contentRef.current?.classList.remove('tw-translate-x-8');
            contentRef.current?.classList.add('tw-opacity-100');
            imageRef.current?.classList.remove('tw-translate-x-8');
            imageRef.current?.classList.add('tw-opacity-100');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="tw-min-h-screen tw-bg-black tw-py-24 tw-px-6 md:tw-px-12 tw-overflow-hidden"
    >
      <div className="tw-max-w-7xl tw-mx-auto">
        <div className="tw-grid lg:tw-grid-cols-2 lg:tw-gap-24 tw-items-center">
          {/* Image Section */}
          <div className="tw-flex tw-justify-center tw-items-center -tw-mr-24 lg:-tw-my-16 tw-relative tw-z-0">
            <div
              className="tw-absolute tw-rounded-full tw-z-0"
              style={{
                width: '280px',
                height: '280px',
                backgroundColor: 'rgba(251, 191, 36, 0.3)',
                boxShadow: '0 0 60px 20px rgba(251, 191, 36, 0.5)',
                filter: 'blur(100px)',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            />
            <img
              ref={imageRef}
              src={TestimonialBanner}
              alt="Testimonial banner"
              className="tw-relative tw-z-10 tw-block tw-h-[90vh] tw-object-contain tw-rounded-3xl tw-transition-all tw-duration-700 tw-opacity-0"
            />
          </div>

          {/* Text Section */}
          <div
            ref={contentRef}
            className="tw-transition-all tw-duration-700 tw-opacity-0 lg:-tw-translate-y-16 tw-text-center lg:tw-text-left tw-flex tw-flex-col tw-items-center lg:tw-items-start tw-max-w-lg tw-mx-auto lg:tw-mx-0"
          >
            <h2 className="tw-text-white tw-text-4xl md:tw-text-5xl tw-font-bold tw-leading-snug tw-mb-6">
              A self-service<br />
              experience <br />
              <span className="tw-text-[#00C5FB]">
                customers<br />want.
              </span>
            </h2>
            <p className="tw-text-gray-300 tw-text-lg tw-mb-4">
              Offer customers hassle-free 24/7 online claim filing with a 96% CSAT score.
              No complaints, just great service.
            </p>
          </div>
        </div>
      </div>

      {/* Testimonial Marquee */}
      <div className="tw-z-20 -tw-mx-6 md:-tw-mx-12 tw-mt-16">
        <Marquee speed={50} gradient={false} pauseOnHover>
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="tw-bg-[#010101] tw-w-[380px] tw-min-h-[230px] tw-flex-shrink-0 tw-flex tw-flex-col tw-justify-between tw-p-8 tw-rounded-[2rem] tw-mr-8 tw-border tw-border-white/5"
            >
              <div>
                <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
                  <FaQuoteLeft className="tw-text-2xl tw-text-white/20" />
                  <div className="tw-relative">
                    {/* Glow behind stars */}
                    <div className="tw-absolute tw-inset-0 tw-bg-[#00C5FB]/25 tw-blur-lg tw-rounded-full" />
                    <div className="tw-relative tw-flex tw-gap-1">
                      {[...Array(t.stars || 5)].map((_, idx) => (
                        <FaStar key={idx} className="tw-text-[#00C5FB] tw-text-lg tw-drop-shadow-[0_0_8px_rgba(0,197,251,0.8)]" />
                      ))}
                    </div>
                  </div>
                </div>
                <p className="tw-text-white tw-text-xl md:tw-text-2xl tw-leading-snug tw-font-bold tw-mb-6">
                  {t.text}
                </p>
              </div>
              <div className="tw-text-left">
                <p className="tw-text-white tw-text-lg tw-font-bold tw-mb-1">
                  {t.author}
                </p>
                <p className="tw-text-gray-500 tw-text-xs md:tw-text-sm">
                  {t.subtitle}
                </p>
              </div>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default SelfService;